import { render, staticRenderFns } from "./ExpensesModule.vue?vue&type=template&id=74ce425d"
import script from "./ExpensesModule.vue?vue&type=script&lang=js"
export * from "./ExpensesModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports